import Home from "./page/home/Home";

function App() {
  return (
    <Home /> 
  );
}

export default App;
